export default {
    name: 'repetition',
    config: {},
    install(Vue, installOptions) {
        Vue.directive('repetition', {
            inserted(el, binding) {
                el.addEventListener('click', () => {
                    if (!el.disabled) {
                        el.disabled = true
                        setTimeout(() => {
                            el.disabled = false
                        }, binding.value || 2000)
                    }
                })
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/directive/repetition.js